export const colors = {
  '0': '#ffffff',
  '1': '#f6f8fc',
  '2': '#f2f2f2',
  '3': '#dfe0e0',
  '4': '#c9cacb',
  '5': '#a1a4af',
  '6': '#6a6d77',
  '7': '#575961',
  '10': '#232427',
  Blue: '#0033a1',
  'Blue 2': '#1d92f0',
  'Labels/Primary': '#000000',
  'Level 10': '#414141',
  'Level 9': '#8A2331',
  'Level 5': '#B4975B',
  'Level 4': '#76BB20',
  'Level 2': '#FF4613',
  'Level 3': '#CF202F',
  'Level 6': '#00A5CD',
  'Level 7': '#F3D100',
  'Level 8': '#066549',
  'Level 1': '#012D96',
  Error: '#ff2d2d',
  Success: '#2d9734',
  'Color 10': '#0f1a2a',
  'Fills/Tertiary': '#7878801f',
  'Labels/Secondary': '#3c3c4399',
  'Labels/Tertiary': '#3c3c434d',
  'Grays/Black': '#000000',
  'Backgrounds/Primary': '#ffffff',
  'Fills/Primary': '#78788033',
  'Neutral 0 [day]': '#ffffff',
  'Neutral 400 [day]': '#828282',
  Red: '#ce0e2d',
  'Fills/Secondary': '#78788029',
  'Separators/Vibrant': '#e6e6e6',
  'Accents/Blue': '#0088ff',
  'Grays/White': '#ffffff',
  'Component Fill': '#f5f5f5',
  'Component Stroke': '#6155f5',
  'Light Alt': '#50555c',
  'Light Ink': '#000000',
  'Light Primary': '#ffffff',
  'Light Secondary': '#aeb3be',
  'Light Background': '#ced2d9',
  'Main/10': '#E8F1FF',
} as const;

export const guardianColors = {
  'Main/Main': '#0033a1',
  'Main/10': '#E8F1FF',
  'Main/40': '#3D64B6',
  'Primary Color': '#F46F02',
  Blue: '#346AE1',
  '1': '#F6F8FC',
  '3': '#E2E8F0',
  '2': '#F1F4F9',
  '4': '#CBD4E1',
  '5': '#9FAEC4',
  '6': '#64748B',
  Error: '#CE0E2D',
  '7': '#D9D9D9', // This color is not named on figma
  '8': '#346AE11A',
  '10': '#252525',
  '11': '#FFF9EF',
  '12': '#FFAA00',
  '13': '#62FF8C',
  'Event/Practice': '#0033A1',
  'Event/Practice Background': '#E8F1FF',
  'Event/Tournament': '#16B99A',
  'Event/Tournament Background': '#DDF7F1',
};

export function withOpacity(hex: string, opacity: number): string {
  const raw = String(hex ?? '')
    .trim()
    .replace('#', '');
  if (raw.length !== 6) return hex;
  const r = parseInt(raw.slice(0, 2), 16);
  const g = parseInt(raw.slice(2, 4), 16);
  const b = parseInt(raw.slice(4, 6), 16);
  if ([r, g, b].some(n => Number.isNaN(n))) return hex;
  const a = Math.max(0, Math.min(1, opacity));
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export type ColorToken = keyof typeof colors;
